import { Injectable } from '@angular/core';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { ITipoProcedimento } from '../models/tipo_procedimento.model';


@Injectable()
export class TipoProcedimentoService extends EntityService<ITipoProcedimento> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'tipo_procedimento',
      pluralBaseEntityEndPoint: 'tipos_procedimento'
    });
  }
}
